import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import Volume from "./Volume";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import { isMobile } from "react-device-detect";
import DtResult from "../../client/tp-studio/tp-result/DtResult.jsx";
import DtRules from "./pop-up/dt-rules.jsx";
import PopUpdragontigerResults from "./tp_plain_result/dragontiger.jsx";


import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function DTVirtual() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);

  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);
  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [b3Val, setB3Val] = useState(0);
  const [b4Val, setB4Val] = useState(0);
  const [b5Val, setB5Val] = useState(0);
  const [b6Val, setB6Val] = useState(0);
  const [b7Val, setB7Val] = useState(0);
  const [b8Val, setB8Val] = useState(0);
  const [b9Val, setB9Val] = useState(0);
  const [b10Val, setB10Val] = useState(0);
  const [b11Val, setB11Val] = useState(0);
  const [b12Val, setB12Val] = useState(0);
  const [b13Val, setB13Val] = useState(0);
  const [lastStatus, setLastStatus] = useState(null);

  const [dragon, setDragon] = useState(0);
  const [tiger, setTiger] = useState(0);
  const [tie, setTie] = useState(0);
  const [dragonEven, setDragonEven] = useState(0);
  const [dragonOdd, setDragonOdd] = useState(0);
  const [tigerEven, setTigerEven] = useState(0);
  const [tigerOdd, setTigerOdd] = useState(0);
  const [dragonRed, setDragonRed] = useState(0);
  const [dragonBlack, setDragonBlack] = useState(0);
  const [tigerBlack, setTigerBlack] = useState(0);
  const [tigerRed, setTigerRed] = useState(0);

  const [dragonWinner, setDragonWinner] = useState(false);
  const [tigerWinner, setTigerWinner] = useState(false);
  const [tieWinner, setTieWinner] = useState(false);

  const [dragonEvenWinner, setDragonEvenWinner] = useState(false);
  const [dragonOddWinner, setDragonOddWinner] = useState(false);

  const [tigerEvenWinner, setTigerEvenWinner] = useState(false);
  const [tigerOddWinner, setTigerOddWinner] = useState(false);

  const [dragonRedWinner, setDragonRedWinner] = useState(false);
  const [dragonBlackWinner, setDragonBlackWinner] = useState(false);

  const [tigerRedWinner, setTigerRedWinner] = useState(false);
  const [tigerBlackWinner, setTigerBlackWinner] = useState(false);

  // Dragon Suit
  const [dragonSpadesWinner, setDragonSpadesWinner] = useState(false);
  const [dragonHeartsWinner, setDragonHeartsWinner] = useState(false);
  const [dragonClubsWinner, setDragonClubsWinner] = useState(false);
  const [dragonDiamondsWinner, setDragonDiamondsWinner] = useState(false);

  // Tiger Suit
  const [tigerSpadesWinner, setTigerSpadesWinner] = useState(false);
  const [tigerHeartsWinner, setTigerHeartsWinner] = useState(false);
  const [tigerClubsWinner, setTigerClubsWinner] = useState(false);
  const [tigerDiamondsWinner, setTigerDiamondsWinner] = useState(false);

  const [resultData, setResultData] = useState([]);
  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= FLIP STATE ================= */
  const [flipStep, setFlipStep] = useState(0);
  const flipTimerRef = useRef(null);
  const lastEvtStatusRef = useRef(null);

  /* ================= DISPLAYED CARDS (IMPORTANT) ================= */
  const [shownCards, setShownCards] = useState({
    c1: "1",
    c2: "1"
  });

  const [shownCards1, setShownCards1] = useState({
    c1: "1"
  });
  const [shownCards2, setShownCards2] = useState({
    c2: "1"
  });

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "DragonTiger_virtual"
  });

  console.log("Socket data:", data);
  const displayRunnerName = (runnerName) => {
    if (runnerName == "b1") return "Dragon";
    else if (runnerName == "b2") return "Tiger";

    return runnerName.replace(/\b\w/g, function (c) {
      return c.toUpperCase();
    });
  };

  /// place bet ///

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      //console.log("placeBetObject: ", placeBetObject);
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };
  //console.log('data: ', data);
  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;
  //console.log(payload);
  //console.log("Status: ", payload?.evt_status);
  // console.log("C1: ", payload?.c1);
  // console.log("C2: ", payload?.c2);
  // console.log("AC3: ", payload?.ac3);
  // console.log("BC1: ", payload?.bc1);
  // console.log("BC2: ", payload?.bc2);
  // console.log("BC3: ", payload?.bc3);

  /* ================= TIMER SYNC ================= */
  useEffect(() => {
    if (!payload) return;
    setDisplayLoader(false);
    updateUserData(data?.user);
    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]); //clearing placed bets on status change
      setDragon(0);
      setTiger(0);
      setTie(0);
      setDragonEven(0);
      setDragonOdd(0);
      setTigerEven(0);
      setTigerOdd(0);
      setDragonRed(0);
      setDragonBlack(0);
      setTigerBlack(0);
      setTigerRed(0);

      setDragonWinner(false);
      setTigerWinner(false);
      setTieWinner(false);

      setDragonEvenWinner(false);
      setDragonOddWinner(false);

      setTigerEvenWinner(false);
      setTigerOddWinner(false);

      setDragonRedWinner(false);
      setDragonBlackWinner(false);

      setTigerRedWinner(false);
      setTigerBlackWinner(false);

      setDragonSpadesWinner(false);
      setDragonHeartsWinner(false);
      setDragonClubsWinner(false);
      setDragonDiamondsWinner(false);

      setTigerSpadesWinner(false);
      setTigerHeartsWinner(false);
      setTigerClubsWinner(false);
      setTigerDiamondsWinner(false);
    }

    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds !== "number") return;

    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setB3Val(payload?.b3);
    setB4Val(payload?.b4);
    setB5Val(payload?.b5);
    setB6Val(payload?.b6);
    setB7Val(payload?.b7);
    setB8Val(payload?.b8);
    setB9Val(payload?.b9);
    setB10Val(payload?.b10);
    setB11Val(payload?.b11);
    setB12Val(payload?.b12);
    setB13Val(payload?.b13);

    setTimeLeft(serverSeconds);

    clearInterval(localTimerRef.current);

    /*if (payload?.result !== "") {
      let result = payload?.result;
      if (result === 1) {
        setDragonWinner(true);
      } else if (result === 2) {
        setTigerWinner(true);
      } else if (result === 3) {
        setTieWinner(true);
      }
      if (payload?.c1 != "") {
        let dragonCard = payload?.c1;
        let lastTwo = dragonCard.slice(-2);
        if (lastTwo == "HH" || lastTwo == "CC") {
          setDragonBlackWinner(true);
        } else {
          setDragonRedWinner(true);
        }

        let removeLastTwo = dragonCard.slice(0, -2);
        if (removeLastTwo == "K") {
          removeLastTwo = 13;
        } else if (removeLastTwo == "Q") {
          removeLastTwo = 12;
        } else if (removeLastTwo == "J") {
          removeLastTwo = 11;
        } else if (removeLastTwo == "A") {
          removeLastTwo = 1;
        }
        if (removeLastTwo % 2 == 0) {
          setDragonEvenWinner(true);
        } else {
          setDragonOddWinner(true);
        }
      }

      if (payload?.c2 != "") {
        let tigerCard = payload?.c2;
        let lastTwo = tigerCard.slice(-2);
        if (lastTwo == "HH" || lastTwo == "CC") {
          setTigerBlackWinner(true);
        } else {
          setTigerRedWinner(true);
        }

        let removeLastTwo = tigerCard.slice(0, -2);
        if (removeLastTwo == "K") {
          removeLastTwo = 13;
        } else if (removeLastTwo == "Q") {
          removeLastTwo = 12;
        } else if (removeLastTwo == "J") {
          removeLastTwo = 11;
        } else if (removeLastTwo == "A") {
          removeLastTwo = 1;
        }
        if (removeLastTwo % 2 == 0) {
          setTigerEvenWinner(true);
        } else {
          setTigerOddWinner(true);
        }
      }
    }*/

    if (payload?.evt_status === "CLOSED") {
      const result = Number(payload?.result);

      setDragonWinner(result === 1);
      setTigerWinner(result === 2);
      setTieWinner(result === 3);

      setDragonEvenWinner(Number(payload?.DragonEven) === 1);
      setDragonOddWinner(Number(payload?.DragonOdd) === 1);

      setTigerEvenWinner(Number(payload?.TigerEven) === 1);
      setTigerOddWinner(Number(payload?.TigerOdd) === 1);

      setDragonRedWinner(Number(payload?.DragonRed) === 1);
      setDragonBlackWinner(Number(payload?.DragonBlack) === 1);

      setTigerRedWinner(Number(payload?.TigerRed) === 1);
      setTigerBlackWinner(Number(payload?.TigerBlack) === 1);

      setDragonSpadesWinner(Number(payload?.DragonSpades) === 1);
      setDragonHeartsWinner(Number(payload?.DragonHearts) === 1);
      setDragonClubsWinner(Number(payload?.DragonClubs) === 1);
      setDragonDiamondsWinner(Number(payload?.DragonDiamonds) === 1);

      setTigerSpadesWinner(Number(payload?.TigerSpades) === 1);
      setTigerHeartsWinner(Number(payload?.TigerHearts) === 1);
      setTigerClubsWinner(Number(payload?.TigerClubs) === 1);
      setTigerDiamondsWinner(Number(payload?.TigerDiamonds) === 1);
    }

    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  /* ================= FLIP SEQUENCE ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;
    if (lastEvtStatusRef.current === payload.evt_status) return;

    lastEvtStatusRef.current = payload.evt_status;
    clearTimeout(flipTimerRef.current);
    setFlipStep(0);

    let step = 1;

    function run() {
      setFlipStep(step);
      step++;

      if (step <= 2) {
        flipTimerRef.current = setTimeout(run, 1000);
      }
    }

    if (payload.evt_status === "CLOSED") {
      flipTimerRef.current = setTimeout(run, 300);
    }

    return () => clearTimeout(flipTimerRef.current);
  }, [payload?.evt_status]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketType
  ) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "dragontiger_virtual"
    };
    placeBetObject.catmid = payload?.cat_mid;
    placeBetObject.round = payload?.cat_mid;
    //console.log("teamname->", teamname);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    //placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 7;
    placeBetObject.market_type = marketType;

    setPlaceBetObject(placeBetObject);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };
  /// place bet ///

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "dragontiger_virtual"
    });
    let books = res?.data;
    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];
        if (obj.Type == "main") {
          setDragon(obj.Dragon);
          setTiger(obj.Tiger);
        } else {
          if (obj.rnr_nam == "tie") {
            setTie(obj.lay);
          } else if (obj.rnr_nam == "tiger black") {
            setTigerBlack(obj.lay);
          } else if (obj.rnr_nam == "tiger red") {
            setTigerRed(obj.lay);
          } else if (obj.rnr_nam == "dragon black") {
            setDragonBlack(obj.lay);
          } else if (obj.rnr_nam == "dragon red") {
            setDragonRed(obj.lay);
          } else if (obj.rnr_nam == "tiger odd") {
            setTigerOdd(obj.lay);
          } else if (obj.rnr_nam == "tiger even") {
            setTigerEven(obj.lay);
          } else if (obj.rnr_nam == "dragon even") {
            setDragonEven(obj.lay);
          } else if (obj.rnr_nam == "dragon odd") {
            setDragonOdd(obj.lay);
          }
        }
      }
    }
  }

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const [profileData, setProfileData] = useState(null);
  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit??data?.myBetLimit?.figure));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const [initialBetsFetched, setInitialBetsFetched] = useState(false);
  const [placedBets, setPlacedBets] = useState([]);
  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const placedBets = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "dragontiger_virtual"
    });

    setPlacedBets(placedBets.data);
  }

  function displayName(index) {
    let txt = "";
    if (index == 1) {
      txt = "DRA";
    } else if (index == 2) {
      txt = "TIG";
    } else {
      txt = "TIE";
    }

    return txt;
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  useEffect(() => {
    document.documentElement.classList.add("cards-bg-black");
    document.documentElement.classList.add("h-100");

    return () => {
      document.documentElement.classList.remove("cards-bg-black");
      document.documentElement.classList.remove("h-100");
    };
  }, []);

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "dragontiger_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  //console.log("here --> ", data.data.data);

  return (
    <>
      {shownCards && (
        <div className="aviator-scope player-scope cards-bg-black">
          <ClientLayoutWithOutHeader showLoader={false}>
            <div class="details-tabs-wrapper1">
              <div className="main-page">
                <div className="row no-gutters">
                  <div className="col-md-12">
                    <div className="bodyheight">
                      <div className="wrapper">
                        <TPStudioSidebar open={open} />
                      </div>

                      <div className="lobby-ctn BPGmaindiv">
                        <TpStudioHeader setOpen={setOpen} open={open} />
                        <TpStudioLoader displayLoader={displayLoader} />
                      </div>

                      <div
                        className="row"
                        style={{ display: displayLoader ? "none" : "" }}
                      >
                        <div className="col-md-8">
                          <div className="left-content">
                            <div>
                              <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                                <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                  <p>DRAGONTIGER</p>
                                </div>
                                <div
                                  className="col-6 col-md-6 inline-block Gameidcol text-right"
                                  style={{ marginTop: "4px" }}
                                >
                                  <div
                                    role="group"
                                    aria-label="Second group"
                                    className="btn-group btn-group-sm mr-2"
                                  >
                                    <button
                                      style={{ fontSize: "14px" }}
                                      type="button"
                                      id="Alltab"
                                      className={
                                        activeTabIndex == 1
                                          ? "tablink btn btn-primary bbactive"
                                          : "tablink btn btn-primary"
                                      }
                                      onClick={() => activeTab(1)}
                                    >
                                      Game
                                    </button>
                                    <button
                                      style={{ fontSize: "14px" }}
                                      type="button"
                                      id="RESULTStab"
                                      className={
                                        activeTabIndex == 2
                                          ? "tablink btn btn-primary bbactive"
                                          : "tablink btn btn-primary"
                                      }
                                      onClick={() => activeTab(2)}
                                    >
                                      Results
                                    </button>
                                    <button
                                      style={{ fontSize: "14px" }}
                                      type="button"
                                      className="tablink btn btn-primary"
                                      onClick={() => setShowRules(true)}
                                    >
                                      Rules
                                    </button>
                                    <DtRules
                                      show={showRules}
                                      onClose={() => setShowRules(false)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="cards-layout blackjack"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div>
                                <div className="cards-layout blackjack">
                                  <div className="col-12 timerDiv2 mb-negative-24">
                                    <div
                                      className="row mt-2"
                                      style={{
                                        display:
                                          activeTabIndex == 1 ? "" : "none"
                                      }}
                                    >
                                      <div className="col-2 col-md-1">
                                        <div className="Connectedclients mt-1">
                                          <i
                                            aria-hidden="true"
                                            className="fa fa-user mr-1"
                                            style={{
                                              fontSize: "14px",
                                              color: "white"
                                            }}
                                          />
                                          <b>
                                            <span
                                              id="UsersCount"
                                              className="number"
                                            >
                                              326
                                            </span>
                                          </b>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="col-md-8"
                                      style={{
                                        display:
                                          activeTabIndex == 1 ? "" : "none"
                                      }}
                                    />

                                    <div
                                      className="col-md-2"
                                      style={{
                                        display:
                                          activeTabIndex == 1 ? "" : "none"
                                      }}
                                    >
                                      {/* Timer with animated stroke + numeric countdown */}
                                      <div className="teenpatti-base-timer">
                                        <svg
                                          viewBox="0 0 100 100"
                                          className="base-timer__svg"
                                        >
                                          <g className="base-timer__circle">
                                            <circle
                                              cx="50"
                                              cy="50"
                                              r="45"
                                              className="base-timer__path-elapsed"
                                            />
                                            <path
                                              strokeDasharray={`${Math.round(
                                                dash
                                              )} ${Math.round(CIRC)}`}
                                              className={`base-timer__path-remaining ${timerColor}`}
                                              d="
                                                M 50, 50
                                                m -45, 0
                                                a 45,45 0 1,0 90,0
                                                a 45,45 0 1,0 -90,0
                                              "
                                            />
                                          </g>
                                        </svg>
                                        <span className="base-timer__label">
                                          {timeLeft == 1 ? 0 : timeLeft}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Players */}
                                  <div
                                    className="table-player"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    {/* PLAYER A */}
                                    <div className="player-dt">
                                      <span className="name">Dragon</span>
                                      <div className="tp-hand">
                                        <div
                                          className={`cards-tp-card ${
                                            flipStep === 1 &&
                                            payload?.evt_status === "CLOSED"
                                              ? "flip"
                                              : ""
                                          }`}
                                        >
                                          <img
                                            src={`/assets/images/cards/${
                                              flipStep >= 1 &&
                                              payload?.evt_status ===
                                                "CLOSED" &&
                                              payload?.c1
                                                ? payload.c1
                                                : "1"
                                            }.svg`}
                                            draggable={false}
                                            style={{
                                              width: isMobile ? "46px" : "70px",
                                              height: isMobile ? "55px" : "85px"
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    {/* PLAYER B */}
                                    <div className="player-dt">
                                      <span className="name">Tiger</span>
                                      <div className="tp-hand">
                                        <div
                                          className={`cards-tp-card ${
                                            flipStep === 2 &&
                                            payload?.evt_status === "CLOSED"
                                              ? "flip"
                                              : ""
                                          }`}
                                        >
                                          <img
                                            src={`/assets/images/cards/${
                                              flipStep >= 2 &&
                                              payload?.evt_status ===
                                                "CLOSED" &&
                                              payload?.c2
                                                ? payload.c2
                                                : "1"
                                            }.svg`}
                                            alt=""
                                            style={{
                                              width: isMobile ? "46px" : "70px",
                                              height: isMobile ? "55px" : "85px"
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      textAlign: "right",
                                      marginRight: "20px",
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                    className="volume-wrapper"
                                  >
                                    <Volume />
                                  </div>
                                  {/* Controls removed (auto mode) */}
                                </div>
                              </div>
                            </div>

                            {/* Footer */}
                            <center
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                                <div className="buttons-div">
                                  {Object.keys(resultList).map((idx) => (
                                    <button
                                      key={idx}
                                      className="video-button border-gradient-btn border-gradient-purple-btn"
                                    >
                                      {displayName(resultList[idx])}
                                    </button>
                                  ))}
                                </div>
                                <div className="round-div">
                                  <div className="label">Round ID:</div>
                                  <div className="id">{payload?.cat_mid}</div>
                                </div>
                              </div>
                            </center>

                            {/* Market Sections (unchanged) */}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div
                                className="tb-content"
                                style={{ background: "#fff" }}
                              >
                                <div className="market-titlebar">
                                  <p className="market-name">
                                    <span className="market-name-badge">
                                      <i className="market-name-icon">
                                        <img
                                          src="/assets/images/time-img.png"
                                          style={{
                                            filter: "invert(100%)",
                                            marginTop: "-8px",
                                            marginLeft: "-1px"
                                          }}
                                        />
                                      </i>
                                      <span>MATCH ODDS </span>
                                      {/*-<span style="text-transform: initial;">
                                                          (MaxBet: 5M) </span></span> <span class="rules-badge"><i class="fa fa-info-circle"></i></span>-*/}
                                    </span>
                                  </p>
                                  <div className="market-overarround">
                                    <span />
                                    <strong>Back</strong>
                                  </div>
                                  <div className="market-overarround market-overarround-lay">
                                    <strong>Lay</strong>
                                  </div>
                                </div>
                                <div className="market-runners">
                                  <div className="runner-runner">
                                    <h3
                                      className={
                                        dragonWinner && flipStep >= 2
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontSize: 16,
                                                      fontWeight: "bold"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Dragon
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        dragon !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        dragon > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(dragon)}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          {suspendedText}
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b1span"
                                        data-teamname="Player A"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "dragon",
                                            "dragon",
                                            b1Val,
                                            "m"
                                          )
                                        }
                                      >
                                        {b1Val}
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="runner-runner">
                                    <h3
                                      className={
                                        tigerWinner && flipStep >= 2
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontSize: 16,
                                                      fontWeight: "bold"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Tiger
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        tiger !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        tiger > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(tiger)}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          {suspendedText}
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b2span"
                                        data-teamname="Tiger"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "Tiger",
                                            "Tiger",
                                            b2Val,
                                            "m"
                                          )
                                        }
                                      >
                                        {b2Val}
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                  <div className="runner-runner">
                                    <h3
                                      className={
                                        tieWinner && flipStep >= 2
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontSize: 16,
                                                      fontWeight: "bold"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Tie
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        tie !== 0 ? "" : "none",
                                                      color:
                                                        tie > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(tie)}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          {suspendedText}
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b2span"
                                        data-teamname="Tie"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "tie",
                                            "tie",
                                            b3Val,
                                            "f"
                                          )
                                        }
                                      >
                                        {b3Val}
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="no-height"
                              style={{ height: "5px" }}
                            ></div>
                            {/*- plus -*/}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>DRAGON ODD-EVEN</span>
                                  </span>
                                </p>
                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      dragonEvenWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Dragon - Even
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      dragonEven !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      dragonEven > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(dragonEven)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Dragon - Even"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "dragon even",
                                          "dragon even",
                                          b5Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b5Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      dragonOddWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Dragon - Odd
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      dragonOdd !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      dragonOdd > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(dragonOdd)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Dragon - Odd"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "dragon odd",
                                          "dragon odd",
                                          b6Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b6Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="no-height"
                              style={{ height: "5px" }}
                            ></div>
                            {/*- plus -*/}
                            {/*- plus -*/}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>TIGER ODD-EVEN</span>
                                  </span>
                                </p>
                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      tigerEvenWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Tiger - Even
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerEven !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerEven > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerEven)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Even"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger even",
                                          "tiger even",
                                          b10Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b10Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      tigerOddWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Tiger - Odd
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerOdd !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerOdd > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerOdd)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Odd"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger odd",
                                          "tiger odd",
                                          b11Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b11Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="no-height"
                              style={{ height: "5px" }}
                            ></div>
                            {/*- plus -*/}
                            {/*- plus -*/}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>DARGON COLOR</span>
                                  </span>
                                </p>
                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      dragonRedWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Dragon - Red
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      dragonRed !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      dragonRed > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(dragonRed)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Dragon - Red"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "dragon red",
                                          "dragon red",
                                          b7Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b7Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      dragonBlackWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Dragon - Black
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      dragonBlack !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      dragonBlack > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(dragonBlack)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Dragon - Black"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "dragon black",
                                          "dragon black",
                                          b8Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b8Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="no-height"
                              style={{ height: "5px" }}
                            ></div>
                            {/*- plus -*/}
                            {/*- plus -*/}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>TIGER COLOR</span>
                                  </span>
                                </p>
                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      tigerRedWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Tiger - Red
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerRed !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerRed > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerRed)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Red"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger red",
                                          "tiger red",
                                          b8Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b8Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      tigerBlackWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Tiger - Black
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerBlack !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerBlack > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerBlack)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Black"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger black",
                                          "tiger black",
                                          b8Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b8Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/*- plus -*/}
                            <div
                              class="no-height"
                              style={{ height: "5px" }}
                            ></div>
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>DRAGON SUIT</span>
                                  </span>
                                </p>
                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      dragonSpadesWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Dragon - Spades
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerRed !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerRed > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerRed)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Red"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger red",
                                          "tiger red",
                                          b12Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b12Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      dragonHeartsWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Dragon - Hearts
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerBlack !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerBlack > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerBlack)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Black"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger black",
                                          "tiger black",
                                          b13Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b13Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      dragonClubsWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Dragon - Clubs
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerBlack !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerBlack > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerBlack)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Black"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger black",
                                          "tiger black",
                                          b13Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b13Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      dragonDiamondsWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Dragon - Diamonds
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerBlack !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerBlack > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerBlack)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Black"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger black",
                                          "tiger black",
                                          b13Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b13Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="no-height"
                              style={{ height: "5px" }}
                            ></div>
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>TIGER SUIT</span>
                                  </span>
                                </p>
                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      tigerSpadesWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Tiger - Spades
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerRed !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerRed > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerRed)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Red"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger red",
                                          "tiger red",
                                          b12Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b12Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      tigerHeartsWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Tiger - Hearts
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerBlack !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerBlack > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerBlack)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Black"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger black",
                                          "tiger black",
                                          b13Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b13Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      tigerClubsWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Tiger - Clubs
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerBlack !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerBlack > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerBlack)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Black"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger black",
                                          "tiger black",
                                          b13Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b13Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      tigerDiamondsWinner && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Tiger - Diamonds
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tigerBlack !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tigerBlack > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tigerBlack)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Tiger - Black"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tiger black",
                                          "tiger black",
                                          b13Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b13Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              display: activeTabIndex == 2 ? "" : "none"
                            }}
                          >
                            <DtResult resultData={resultData} />
                          </div>
                        </div>

                        <div className="col-md-4">
                          {showBetSlipPopup && (
                            <TPPopUpBetSlip
                              closeBetSlipParent={closeBetSlipMobile}
                              betObj={placeBetObject}
                              placeBetParent={placeBet}
                              betButtonShow={betButtonShow}
                              betErrorMessageObj={betErrorMessageObj}
                              betButtonShowLoaderShow={betButtonShowLoaderShow}
                              profileData={profileData}
                            />
                          )}
                          <TeenPattisCasinoBetslipWeb
                            showBetSlip={showBetSlip}
                            placeBetObject={placeBetObject}
                            closeBetSlipParent={closeBetSlip}
                            placeBetParent={placeBet}
                            betErrorMessageObj={betErrorMessageObj}
                            profileData={profileData}
                          ></TeenPattisCasinoBetslipWeb>
                          <div>
                            <div
                              class="no-height"
                              style={{ height: "5px" }}
                            ></div>
                            <div className="bets">
                              <strong>
                                Matched Bets (0)
                                <img
                                  src={reconnecting}
                                  alt="dc"
                                  className="rounded disconnected"
                                  style={{ display: "none" }}
                                />{" "}
                              </strong>
                              <div className="betting-table">
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th>Runner</th>
                                      <th>Price</th>
                                      <th>Size</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {placedBets.map((bet, index) => {
                                      console.log("MATCHED BET:", bet);

                                      return (
                                        <tr
                                          key={index}
                                          style={{
                                            background:
                                              bet.type == "b"
                                                ? "#e9f6fc"
                                                : "#fce3e4"
                                          }}
                                        >
                                          <td>
                                            {displayRunnerName(bet.rnr)} - (
                                            {bet.cat_mid})
                                          </td>

                                          <td>{bet.amnt}</td>
                                          <td>{bet.rate}</td>
                                          <td></td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ClientLayoutWithOutHeader>

          <style>
            {`
          .cards-tp-card {
            margin-top: 0px;
          }
            .player-scope .table-player {
          gap: 26px !important;
        }
          .player-scope .table-player .player-dt {
            display: flex !important;
            flex-direction: column;
            align-items: center !important;
            max-width: none;
            width: auto;
            color: #d7bc7b !important;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 700;
          }
          .tb-content{
            padding-top:3px;
          }

          .aviator-scope .home-content {
            margin-top: 0 !important;
          }

          .aviator-scope .cards-layout.blackjack {
            position: relative;
            background: #000000;
            min-height: 225px;
          }

          .aviator-scope .cards-layout.blackjack::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: radial-gradient(
              ellipse 100% 44% at 50% calc(30% + 40px),
              rgba(62, 193, 65, 0.95) 0%,
              rgba(62, 193, 65, 0.8) 15%,
              rgba(30, 80, 35, 0.5) 40%,
              #1e1e1e 55%,
              #1e1e1e 100%
            );
            opacity: 0.4;
            pointer-events: none;
            z-index: 0;
          }

          .aviator-scope .cards-layout.blackjack > * {
            position: relative;
            z-index: 1;
          }

/* ---------------- DESKTOP ---------------- */

        @media (min-width:992px){
          .table-player .player-name{
            font-size:13px;
          }
          .market-titlebar .market-name-badge span,
          .market-titlebar .market-overarround strong,
          .market-titlebar .market-overarround-lay strong{
            font-size:14px;
          }
          .player-scope .tp-hand {
            position: relative;
            width: 180px !important;
            height: 100px !important;
            margin: 10px -10px;
            overflow: visible;
            border-radius: 12px;
            border: 1px solid rgba(178, 220, 175, 0.25);
          }
          .aviator-scope .row{
            margin-left:0 !important;
            margin-right:0 !important;
          }
          .col-md-8{
            padding-left:19px !important;
            margin-bottom:9px;
          }
          .left-content{
            padding-right:6px;
          }
          .aviator-scope .col-12{
            padding-left:0 !important;
            padding-right:0 !important;
          }
          .left-content .market-titlebar {
            width: 100%;
            display: flex;
            height: 20px;
          }
          .runner-runner .lobby-btn {
            height: 38px !important;
            min-height: 38px !important;
            padding: 2px 4px !important;
          }
          .aviator-scope .cards-layout.blackjack {
            min-height: 225px;
          }
          .volume-wrapper {
            margin-top: -35px;
          }
        }

/* ---------------- MOBILE---------------- */
        @media (max-width:991px){
          .table-player{
            font-size:16px !important;
          }
          .market-titlebar strong{
            font-size:13px;
          }
          .col-md-8{
            padding-left:15px !important;
          }
          .left-content{
            padding-right:0;
          }
        }
        @media (max-width:576px){
              .no-height{
                height: 0 !important;
              }
          .aviator-scope .cards-layout.blackjack {
            min-height: 130px !important;
          }
          .player-scope .cards-tp-card img{
            height: 50px;   /* reduce until it fits */
            width: auto;
            border-radius: 6px;
          }
          .player-scope .tp-hand {
            position: relative;
            width: 150px !important; 
            height: 60px !important;  
            margin: 4px 4px;    
            overflow: visible;
            border-radius: 12px;
            border: 1px solid rgba(178, 220, 175, 0.25);     
          }
          .footer-divbpg{
            display:flex;
            align-items:center;
            justify-content:space-between;
            flex-wrap:nowrap; 
            border-radius:8px;
          }
          .aviator-scope .col-12{
            padding-left:0 !important;
            padding-right:0 !important;
          }
          .titlebarname p{
            font-size:18px !important;
          }
          .player-scope .table-player {
            justify-content: center; 
            gap: 1px !important;  
            padding: 0 10px !important;         
          }
          .btn-group-sm .btn{
            padding:2px 6px;
            font-size:12px;
          }
          .btn-group{
            flex-wrap:nowrap !important;
          }
          .footer-divbpg .btn-group-sm .btn{
            padding:6px 4px !important;
            font-size:12px !important;
            line-height:1.2;
            margin-top: 0;
          }
          .footer-divbpg .titlebarname{
            flex:1;         
            max-width:none !important;
            padding-left:4px;
          }
          .titlebarname p{
            font-size:17px !important;
            margin:0;
            margin-bottom: 12px;
            margin-left: 18px;
          }
          .tp20-player{
            width:48% !important;  
          }
          .tp20-hand{
            width:100% !important;
          }
          @scope (.aviator-scope) {
            .video-button {
              padding: 0px;
              background-color: #4f4f4f;
              color: #fff;
              font-family: Montserrat-ExtraBold;
              font-size: 12px !important;
              font-style: normal;
              font-weight: 500;
              height: 35px !important;
              margin-right: 3px;
              text-align: center;
              width: 1px !important;
              max-width: auto;
            }
          }
        }
          @media (max-width: 768px) {
            .aviator-scope ul.top-nav,
            .aviator-scope .top-nav {
              padding-left: 0 !important;
            }

            .timerDiv2 {
              margin-bottom: 0 !important;
            }
            .footer-divbpg {
              margin-top: 0 !important;
            }
            .volume-wrapper {  
              height: 10px !important;
              margin-top: -7px !important;
              line-height: 16px;
              margin-bottom: 10px;
            }
          }
        
        .tp-hand {
          display: flex;
          justify-content: center; 
          align-items: center; 
        }
    
      `}
          </style>
        </div>
      )}
    </>
  );
}